export function visibilityPct(
  s: { total?: number; max?: number } | undefined
): number {
  if (!s || !s.max) return 0
  return ((s.total ?? 0) / s.max) * 100
}

export function ratePct(rate: number | undefined): number {
  return Math.round((rate ?? 0) * 100)
}

export function engineCeiling(totalQueries: number): number {
  return totalQueries * 10
}

const ENGINE_LABELS: Record<string, string> = {
  openai: 'ChatGPT',
  anthropic: 'Claude',
  google: 'Gemini',
  xai: 'Grok',
  deepseek: 'DeepSeek',
}

export function engineLabel(engineId: string): string {
  return ENGINE_LABELS[engineId] ?? engineId
}

// The wire/DB value stays `intent_map` (stable token); the UI reads "Gap Finder".
const MODE_LABELS: Record<string, string> = {
  direct: 'Direct',
  grounded: 'Grounded',
  intent_map: 'Gap Finder',
}

// modeLabel turns a run's stored mode (e.g. "intent_map") into the human label
// shown in the UI. Falls back to the raw value so an unknown mode is still legible.
export function modeLabel(mode: string): string {
  return MODE_LABELS[mode] ?? mode
}

export const ALL_ENGINES = [
  'openai',
  'anthropic',
  'google',
  'xai',
  'deepseek',
] as const
